module.exports = "/_next/static/images/slide3-2c9349e1ece0027fc953858360836e62.jpg.webp";